module.exports = __webpack_public_path__ + "static/Glober_Regular-d3ce00da6c0646e95f6be9cda5e62c67.ttf";